"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var Section = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var theme = core_1.useTheme();
    var elevation = (_a = props.elevation) !== null && _a !== void 0 ? _a : 1;
    var elevationOnFocus = (_b = props.elevationOnFocus) !== null && _b !== void 0 ? _b : elevation + 3;
    var variant = (_c = props.variant) !== null && _c !== void 0 ? _c : "elevation";
    var square = (_d = props.square) !== null && _d !== void 0 ? _d : false;
    var showIf = (_e = props.showIf) !== null && _e !== void 0 ? _e : true;
    var spacing = (_f = props.spacing) !== null && _f !== void 0 ? _f : 2;
    var padding = (_g = props.padding) !== null && _g !== void 0 ? _g : spacing;
    var gap = (_h = props.gap) !== null && _h !== void 0 ? _h : spacing * 1.5;
    var _j = react_1.useState(false), focus = _j[0], setFocus = _j[1];
    var handleClickOn = function () {
        setFocus(true);
    };
    var handleClickAway = function () {
        setFocus(false);
    };
    return (react_1.default.createElement("div", null, showIf && (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: handleClickAway },
        react_1.default.createElement(core_1.Paper, { variant: variant, elevation: focus ? elevationOnFocus : elevation, onMouseDown: handleClickOn, square: square, style: __assign({ backgroundColor: "transparent", paddingTop: theme.spacing(padding * 1.5), paddingBottom: theme.spacing(padding * 1.5), paddingRight: theme.spacing(padding), paddingLeft: theme.spacing(padding), marginTop: theme.spacing(padding * 2), marginBottom: theme.spacing(padding * 2) }, props.style) },
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: theme.spacing(gap),
                } }, props.children))))));
};
exports.default = Section;
